export const closeBrowserTab = (): void => {
  // @ts-ignore use to indicate that the browser has opened the tab itself
  window.opener = null
  // @ts-ignore
  window.open("", "_self")
  // @ts-ignore
  window.close()
}
